export default {
    DEU: {
        plans: {
            'weekly': 'wöchentlich',
            'fortnightly': 'vierzehntägig',
            'three-weekly': 'dreiwöchentlich',
            'monthly': 'monatlich',
        },
    },

    USA: {
        plans: {
            'weekly': 'weekly',
            'fortnightly': 'every other week',
            'three-weekly': 'every three weeks',
            'monthly': 'once a month',
        },
    },
};
